import { render, staticRenderFns } from "./ResizeSocial.vue?vue&type=template&id=6be5fa68&scoped=true&"
import script from "./ResizeSocial.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ResizeSocial.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ResizeSocial.vue?vue&type=style&index=0&id=6be5fa68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be5fa68",
  null
  
)

export default component.exports